var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"os-black",staticStyle:{"opacity":"0.8"},attrs:{"id":"view-blog"},domProps:{"innerHTML":_vm._s(_vm.blog.body)}})}
var staticRenderFns = []

export { render, staticRenderFns }